import { Avatar } from "primereact/avatar";
import MeaLink from "./MeaLink";


const MeaStudentRegistrationAvatar = ({ student, permission }) => {
  return (
    <MeaLink
      to={"/school/" + student?.school_id + "/admin/registrations/" + student?.training_id + "/candidates/" + student?.id}
      permission={permission}
    >
      <Avatar
        className="mr-2 p-overlay-badge"
        icon="pi pi-user"
        shape="circle"
        image={
          student?.member?.avatar
            ? student?.member?.avatar + "?u=" + student?.member?.updated_at
            : ""
        }
        label={
          student?.member?.lastname
            ? Array.from(student?.member?.lastname)[0] +
            (student?.member?.firstname
              ? Array.from(student?.member?.firstname)[0]
              : "")
            : student?.member?.name
              ? Array.from(student?.member?.name)[0]
              : ""
        }
        size="normal"
      ></Avatar>
      <span>
        {
          (student?.lastname || student?.member?.lastname || "") +
          " " +
          (student?.firstname || student?.member?.firstname || "")}
      </span>
    </MeaLink>
  );
};
export default MeaStudentRegistrationAvatar;
